import React, { useState } from 'react';
import ContactModal from './ContactModal';
import ReturnPolicyModal from './ReturnPolicyModal';
import './Footer.css';

function Footer() {
  const [showContact, setShowContact] = useState(false);
  const [showPolicy, setShowPolicy] = useState(false);

  return (
    <>
      <footer className="footer">
        <div className="footer-content">
          <button 
            className="contact-button"
            onClick={() => setShowContact(true)}
          >
            Contact Us
          </button>
          <button
            className="policy-button"
            onClick={() => setShowPolicy(true)}
          >
            Return Policy
          </button>
          <p className="copyright">
            © 2026 Sambas Energy LLC. All rights reserved.
          </p>
        </div>
      </footer>

      {showContact && (
        <ContactModal onClose={() => setShowContact(false)} />
      )}
      {showPolicy && (
        <ReturnPolicyModal onClose={() => setShowPolicy(false)} />
      )}
    </>
  );
}

export default Footer;
